import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/emailgroup',
  component: () => import('@views/EmailGroup/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'emailgroup.index',
      component: () => import('@/components/EmailGroup/EmailGroup')
    }
  ]
}
